import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';

// Firebase imports
import { initializeApp, provideFirebaseApp, getApp } from '@angular/fire/app';
import { provideAnalytics, getAnalytics } from '@angular/fire/analytics';
import { provideAuth, getAuth } from '@angular/fire/auth';
import {
  initializeFirestore,
  provideFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from '@angular/fire/firestore';
import { provideStorage, getStorage } from '@angular/fire/storage';
// --- CORRECTED: Added imports for Realtime Database ---
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { environment } from './../environments/environment';

// Other component imports
import { AppRoutingModule } from './app-routing.module';

// Other libraries
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NgxPrintModule } from 'ngx-print';
import { NgxFileDropModule } from 'ngx-file-drop';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Cookie service
import { CookieService } from 'ngx-cookie-service';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    NgxDocViewerModule,
    NgxPrintModule,
    NgbModule,
    NgxFileDropModule,
  ],
  providers: [
    CookieService,
    provideHttpClient(withInterceptorsFromDi()),
    provideFirebaseApp(() => {
      try {
        return initializeApp(environment.firebase);
      } catch (error) {
        console.error('Firebase initialization error:', error);
        throw error;
      }
    }),
    provideAnalytics(() => getAnalytics()),
    provideAuth(() => getAuth()),
    provideFirestore(() => {
      const app = getApp();
      return initializeFirestore(app, {
        localCache: persistentLocalCache({
          tabManager: persistentMultipleTabManager(),
        }),
      });
    }),
    provideStorage(() => getStorage()),
    provideMessaging(() => getMessaging()),
    // --- CORRECTED: Added the provider for the Realtime Database ---
    provideDatabase(() => getDatabase()),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
